import apiClient from './client';

export const DoctorAxiosInstance = apiClient;